var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub-menu-mobile"},[_c('BaseContainer',[_c('FormSelect',{attrs:{"semi":""}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }